import { Link, useLocation } from '@tanstack/react-router';
import { 
  LayoutDashboard, 
  Users, 
  Box, 
  Server,
  Settings,
} from 'lucide-react';
import { cn } from '@/lib/utils';
import { ThemeToggleCompact } from '@/components/ThemeToggle';

const navItems = [
  { path: '/', label: 'Home', icon: LayoutDashboard },
  { path: '/customers', label: 'Customers', icon: Users },
  { path: '/instances', label: 'Instances', icon: Box },
  { path: '/servers', label: 'Servers', icon: Server },
  { path: '/settings', label: 'Settings', icon: Settings },
];

export function BottomNav() {
  const location = useLocation();

  return (
    <nav className="md:hidden fixed bottom-0 left-0 right-0 z-50 bg-sidebar/95 backdrop-blur-lg border-t border-sidebar-border safe-area-bottom">
      <div className="flex items-center justify-around px-2 h-16">
        {navItems.map((item) => {
          const isActive = location.pathname === item.path || 
            (item.path !== '/' && location.pathname.startsWith(item.path));
          const Icon = item.icon;
          
          return (
            <Link
              key={item.path}
              to={item.path}
              className={cn(
                "flex flex-col items-center justify-center gap-1 px-3 py-2 min-w-[56px] min-h-[44px] rounded-xl transition-all duration-200 active:scale-95",
                isActive 
                  ? "text-foreground bg-sidebar-accent" 
                  : "text-sidebar-foreground/60 active:bg-sidebar-accent/50"
              )}
            >
              <Icon className={cn(
                "h-5 w-5 transition-transform",
                isActive && "scale-110"
              )} />
              <span className={cn(
                "text-[10px] font-medium transition-all",
                isActive ? "opacity-100" : "opacity-70"
              )}>
                {item.label}
              </span>
            </Link>
          );
        })}
        
        {/* Theme toggle - no label on mobile */}
        <ThemeToggleCompact />
      </div>
    </nav>
  );
}
